import * as React from "react";

export enum MediaOrientation {
    Portrait,
    Landscape
}

export const useMediaQuery = () => {
    const matchPortrait = window.matchMedia('(orientation: portrait)');
    const [orientation, setOrientation] = React.useState(matchPortrait.matches ? MediaOrientation.Portrait : MediaOrientation.Landscape);

    const getOrientation = (e: any) => {
        if (e.matches) {
            setOrientation(MediaOrientation.Portrait)
        } else  {
            setOrientation(MediaOrientation.Landscape);
        }
    }

    React.useEffect(() => {
        matchPortrait.addListener(getOrientation);
        return () => matchPortrait.removeListener(getOrientation);
    }, [])

    return orientation;
}


// WEBPACK FOOTER //
// ./src/hooks/useMediaQuery.hook.ts